<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content [ngClass]="{'disable-select-state': oneSelectorOnly}">

  @if (showCustomSelector) {
    <div class="custom"
      [ngClass]="{selected: currentSelection == 'CUSTOM'}"
      (click)="currentSelection='CUSTOM'">
      <div class="flex-center">
        <div class="select-wrapper">
          <mbnm-lazy-size-select [range]="project.size.widthRange" [(ngModel)]="project.size.width"
            (click)="currentSelection='CUSTOM'">
          </mbnm-lazy-size-select>
        </div>
        <div class="x">
          x
        </div>
        <div class="select-wrapper">
          <mbnm-lazy-size-select [range]="project.size.heightRange" [(ngModel)]="project.size.height"
            (click)="currentSelection='CUSTOM'">
          </mbnm-lazy-size-select>
        </div>
      </div>
    </div>
  }

  @if (selectorType == 'ALL') {
    <div class="or"> OR </div>
  }

  @if (showStandardSelector) {
    <div class="standard-sizes"
      [ngClass]="{selected: currentSelection == 'STANDARD', standardSelectionMade: standardSelectionMade && !showOpeningSizes}">
      <mbnm-standard-sizes (click)="currentSelection='STANDARD'"
        [showOpeningSizes]="showOpeningSizes"
        [filterList]="standardSizeFilterList"
        [mode]="selectorType"
      (selectionChanged)="selectionChanged($event)"></mbnm-standard-sizes>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="fx-layout-row fx-align--space-between-x">
  <button mat-flat-button color="primary" [mat-dialog-close]="selectedSize"
    [disabled]="!selectedSize || !selectedSize.outer || !selectedSize.outer[0] || !selectedSize.outer[1]">
    OK
  </button>

  <button mat-flat-button color="secondary" mat-dialog-close>
    Cancel
  </button>
</mat-dialog-actions>
